<ng-container [formGroup]="formGroup">
  <div class="row row-cols-md-2 row-cols-sm-1">
    <div class="col">
      <div class="form-check">
        <input
          type="radio"
          [id]="name + 'CoveredFalse'"
          [value]="false"
          formControlName="covered"
        />
        <label class="form-check-label" [attr.for]="name + 'CoveredFalse'"
          >Non</label
        >
      </div>
      <div class="form-check">
        <input
          type="radio"
          [id]="name + 'CoveredTrue'"
          [value]="true"
          formControlName="covered"
        />
        <label class="form-check-label" [attr.for]="name + 'CoveredTrue'"
          >Oui</label
        >
      </div>
    </div>
  </div>
  <div class="row row-cols-md-2 row-cols-sm-1 my-3" *ngIf="isCovered">
    <div class="col">
      <label i18n>Somme d'assurance</label>
      <input
        type="number"
        min="0"
        class="form-control"
        formControlName="insuredSum"
      />
    </div>
    <div class="col">
      <label i18n>Franchise</label>
      <input
        type="number"
        min="0"
        class="form-control"
        formControlName="deductible"
      />
    </div>
  </div>
</ng-container>
